import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpCircle } from "lucide-react";
import { track } from "@/pwa/analytics";

// Notifies the user when a new service-worker version is waiting, and applies it on request.
export function UpdateToast() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = () => setShow(true);
    window.addEventListener("pwa:update-available", handler);
    return () => window.removeEventListener("pwa:update-available", handler);
  }, []);

  const update = () => {
    const waiting = (window as unknown as { __pwaWaiting?: ServiceWorker | null }).__pwaWaiting;
    track("pwa_update_completed");
    if (waiting) {
      waiting.postMessage({ type: "SKIP_WAITING" });
    } else {
      window.location.reload();
    }
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="pwa-update-toast"
          initial={{ opacity: 0, y: -16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -16 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-4 top-4 z-[70] mx-auto flex max-w-md items-center gap-4 rounded-2xl border border-safety/40 bg-obsidian-deep/95 p-4 shadow-[0_24px_60px_-20px_rgba(0,0,0,0.8)] backdrop-blur-2xl"
          style={{ marginTop: "env(safe-area-inset-top)" }}
        >
          <ArrowUpCircle size={20} className="shrink-0 text-safety" />
          <div className="flex min-w-0 flex-col">
            <span className="font-display text-sm font-semibold text-white">A new BuildEase update is available</span>
            <span className="font-sans text-xs text-white/55">Update now to access the latest improvements.</span>
          </div>
          <button type="button" data-testid="pwa-update-btn" onClick={update} className="ml-auto shrink-0 rounded-xl bg-safety px-4 py-2 font-display text-xs font-semibold text-obsidian transition-opacity duration-200 hover:opacity-90">
            Update
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
